define('webshopLandingpagesListCategoryView',[
  'app',
  'module',
  'backbone',
  'underscore',
  'settings',
  'tableFieldView',
  'webshopCategorySelectView',
  'template!webshopLandingpagesListCategoryView',
  'entities/webshop/categories'
], function (
  App,
  Module,
  Backbone,
  _,
  Settings,
  FieldView,
  CategorySelectView,
  Tpl
) {
  'use strict';

  Module.exports = FieldView.extend({
    template: Tpl,
    className: 'category-view ' + FieldView.prototype.className,

    regions: {
      categorySelectRegion: '.category-select-region'
    },

    modelEvents: {
       'change:categoryId': 'render'
    },

    onRender: function () {     
      this.categorySelectView = new CategorySelectView({
        model: new Backbone.Model({
          id: this.model.get('categoryId'),
          code: this.model.get('categoryCode')          
        }),
        onChange: _.bind(function (model) {
          var defer = $.Deferred();
          this.model.setParentId(model.get('id')).done(_.bind(function () {
            this.model.fetch();
            defer.resolve();
          }, this));            
          return defer.promise();
        }, this)       
      });      
      this.getRegion('categorySelectRegion').show(this.categorySelectView);
    }
  });
});
